import { NgModule           } from '@angular/core';
import { MatIconModule      } from "@angular/material/icon";

import { HttpClientModule   } from "@angular/common/http";

import { MatIconRegistry    } from "@angular/material/icon";
import { DomSanitizer       } from "@angular/platform-browser";
import { CustomIcon         } from 'src/app/beans/utils/custom-icon/custom-icon.bean';

@NgModule ({
    imports: [
        MatIconModule   ,
        HttpClientModule
    ]
})
export class CustomIconsModule { 
    
    icons: CustomIcon[] = [
       
    ]
  
    constructor(
        private matIconRegistry : MatIconRegistry,
        private domSanitizer    : DomSanitizer
    ){ this.addIcons() }
    
    addIcons()
    {
        this.icons.forEach( icon => this.addIcon(icon) )
    }
    
    addIcon(icon: CustomIcon)
    {
        this.matIconRegistry.addSvgIcon(
            icon.name,
            this.domSanitizer.bypassSecurityTrustResourceUrl(icon.path)
        );
    }
}
